import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ResourceService } from '@teem/generic/resource.service';
import { products as ProductApi } from '@teem/constants/api';
import { Product, ProductSerializer } from '@teem/models/product';
import { objectToFormData } from '@teem/helpers/functions';

@Injectable({
  providedIn: 'root'
})
export class ProductService extends ResourceService<Product> {

  constructor(httpClient: HttpClient) {
    super(
      httpClient,
      ProductApi.endPoint,
      new ProductSerializer()
    )
  }

  public action(params: any) {
    return this.httpClient.patch(`${ProductApi.action}`, params);
  }

  public commonData() {
    return this.httpClient.get(`${ProductApi.common}`, this.httpOptions);
  }

  public categories() {
    return this.httpClient.get(`${ProductApi.stats}`, this.httpOptions);
  }

  public importFile(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      return this.httpClient.post(`${ProductApi.importFile}`, fd)
    } else {
      return this.httpClient.put(`${ProductApi.importFile}`, params)
    }
  }

  public allProducts() {
    return this.httpClient.get(`${ProductApi.allProducts}`)
  }

  public updateCreateCategory(params: any) {
    return this.httpClient.post(`${ProductApi.updateCreateCategory}`, params);
  }

  public reorderCategory(params: any) {
    return this.httpClient.post(`${ProductApi.reorderCategory}`, params);
  }

  public reorderProduct(params: any) {
    return this.httpClient.post(`${ProductApi.reorderProduct}`, params);
  }

  public updateProducts(products :any) {
    return this.httpClient.post(`${ProductApi.bulkUpdate}`, products);
  }
}
